
(function () {
  if (window.__hokoShopTheLookBootstrapped) return
  window.__hokoShopTheLookBootstrapped = true

  const instances = new Map()
  const stlProductDataByBlockId = new Map()
  const stlProductDataByProductId = new Map()
  const stlProductFetchByHandle = new Map()
  let stlProgrammaticUpdate = false

  function formatMoney(cents, format) {
    if (typeof theme !== 'undefined' && theme.Shopify && theme.Shopify.formatMoney) {
      return theme.Shopify.formatMoney(cents, format || theme.money_format)
    }
    const amount = (cents / 100).toFixed(2)
    return '€' + amount
  }

  function getDropdownOptionValue(selector) {
    const select = selector.querySelector('select')
    if (select) return select.value || ''
    const ccSelect = selector.querySelector('.cc-select')
    if (!ccSelect) return ''
    const selected =
      ccSelect.querySelector('.cc-select__option[aria-selected="true"]') ||
      ccSelect.querySelector('.cc-select__option')
    return selected ? selected.dataset.value ?? '' : ''
  }

  function normalizeOptionValue(value) {
    if (value == null || value === '') return ''
    return String(value).trim()
  }

  function optionValuesMatch(a, b) {
    if (a == null || a === '' || b == null || b === '') return a == b
    return normalizeOptionValue(a) === normalizeOptionValue(b) || a == b
  }

  function hasCompleteOptionSelection(selectedOptions) {
    return selectedOptions.some((opt) => opt != null && opt !== '')
  }

  function optionsMatchVariant(selectedOptions, variant) {
    const opts = variantOptionValues(variant)
    if (!hasCompleteOptionSelection(selectedOptions)) return false
    const len = Math.max(opts.length, selectedOptions.length)
    for (let i = 0; i < len; i++) {
      const selected = selectedOptions[i]
      if (selected == null || selected === '') continue
      if (!optionValuesMatch(selected, opts[i])) return false
    }
    return true
  }

  function getSelectedOptions(productEl) {
    const options = []
    productEl.querySelectorAll('.option-selector').forEach((selector) => {
      const type = selector.dataset.selectorType
      if (type === 'dropdown') {
        options.push(getDropdownOptionValue(selector))
      } else {
        const fieldset = selector.querySelector('.option-selector-fieldset') || selector
        const checked =
          fieldset.querySelector('input[type="radio"]:checked') ||
          selector.querySelector('input[type="radio"]:checked')
        if (checked) {
          options.push(checked.value)
        } else {
          const required = fieldset.querySelector('input[type="radio"][required]')
          options.push(required ? required.value : '')
        }
      }
    })
    return options
  }

  function isVariantPurchasable(variant) {
    if (!variant || !variant.id) return false
    if (variant.available === false) return false
    return true
  }

  function forceFirstAvailableVariant(productEl) {
    const data = getProductData(productEl)
    if (!data || !data.variants.length) return false
    const candidate = data.variants.find((v) => isVariantPurchasable(v)) || data.variants[0]
    if (!candidate) return false
    setProductOptionValues(productEl, variantOptionValues(candidate), { silent: true })
    return true
  }

  function getCartAddUrl() {
    const base =
      (typeof theme !== 'undefined' && theme.routes && theme.routes.cart_add_url) ||
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add'
        : '/cart/add')
    return base.replace(/\/$/, '') + '.js'
  }

  function openMiniCartAfterAdd() {
    if (typeof window.openMiniCart === 'function') {
      window.openMiniCart()
      return
    }
    document.querySelector('.btn-trigger-open-mini-cart')?.click()
  }

  function setProductOptionValues(productEl, values, opts = {}) {
    const silent = opts.silent === true
    const selectors = productEl.querySelectorAll('.option-selector')
    selectors.forEach((selector, index) => {
      const value = values[index]
      if (!value) return
      if (selector.dataset.selectorType === 'dropdown') {
        const select = selector.querySelector('select')
        if (select) {
          select.value = value
          if (!silent) select.dispatchEvent(new Event('change', { bubbles: true }))
        } else {
          const ccSelect = selector.querySelector('.cc-select')
          if (!ccSelect) return
          const option = [...ccSelect.querySelectorAll('.cc-select__option')].find((o) =>
            optionValuesMatch(o.dataset.value ?? '', value)
          )
          if (!option) return
          const current = ccSelect.querySelector('.cc-select__option[aria-selected="true"]')
          if (current && current !== option) {
            current.setAttribute('aria-selected', 'false')
          }
          option.setAttribute('aria-selected', 'true')
          if (!silent) ccSelect.dispatchEvent(new Event('change', { bubbles: true }))
        }
      } else {
        const radios = selector.querySelectorAll('input[type="radio"]')
        const radio = [...radios].find((r) => optionValuesMatch(r.value, value))
        if (radio && !radio.checked) {
          radio.checked = true
          if (!silent) radio.dispatchEvent(new Event('change', { bubbles: true }))
        }
      }
    })
  }

  function isStlSizeSelector(selectorContainer) {
    return selectorContainer?.classList.contains('option-selector--size')
  }

  function getSwatchOptionIndexes(productEl) {
    const indexes = new Set()
    productEl.querySelectorAll('.option-selector--swatch').forEach((el) => {
      const idx = parseInt(el.getAttribute('data-option-index'), 10)
      if (!Number.isNaN(idx)) indexes.add(idx)
    })
    return indexes
  }

  function clearStlSwatchAvailability(productEl) {
    productEl.querySelectorAll('.option-selector--swatch input[type="radio"]').forEach((input) => {
      input.classList.remove('is-unavailable', 'js-option-is-unavailable')
      input.disabled = false
      const label = getOptionInputLabel(productEl, input)
      label?.classList.remove('is-unavailable')
      label?.removeAttribute('aria-disabled')
    })
  }

  function reconcileStlProductOptions(productEl) {
    const data = getProductData(productEl)
    if (!data || !data.variants.length) return false

    const options = getSelectedOptions(productEl)
    const variant = findVariant(data, options)
    if (variant && isVariantPurchasable(variant)) return false

    const lockIndexes = getSwatchOptionIndexes(productEl)
    const candidate = data.variants.find((v) => {
      if (!isVariantPurchasable(v)) return false
      const vOpts = variantOptionValues(v)
      for (const idx of lockIndexes) {
        if (options[idx] && !optionValuesMatch(vOpts[idx], options[idx])) return false
      }
      return true
    })

    if (!candidate) return false

    setProductOptionValues(productEl, variantOptionValues(candidate), { silent: true })
    return true
  }

  function findVariant(productData, selectedOptions) {
    const variants = productData?.variants
    if (!Array.isArray(variants) || !variants.length) return null
    if (!selectedOptions.length || !hasCompleteOptionSelection(selectedOptions)) {
      return variants.find((v) => isVariantPurchasable(v)) || variants[0] || null
    }
    const available = variants.find((variant) => {
      if (!variant.available) return false
      return optionsMatchVariant(selectedOptions, variant)
    })
    if (available) return available
    return variants.find((variant) => optionsMatchVariant(selectedOptions, variant)) || null
  }

  function variantOptionValues(variant) {
    if (!variant) return []
    if (Array.isArray(variant.options) && variant.options.length) {
      return variant.options.filter((v) => v != null && v !== '')
    }
    return [variant.option1, variant.option2, variant.option3].filter((v) => v != null && v !== '')
  }

  function isOptionValueAvailable(productData, selectedOptions, optionIndex, optionValue) {
    const variants = productData?.variants
    if (!Array.isArray(variants) || !variants.length) return false
    const testOptions = selectedOptions.slice()
    testOptions[optionIndex] = optionValue
    const matchingVariant = variants.find((variant) => {
      const vOpts = variantOptionValues(variant)
      for (let i = 0; i < testOptions.length; i++) {
        const selected = testOptions[i]
        if (selected == null || selected === '') continue
        if (!optionValuesMatch(vOpts[i], selected)) return false
      }
      return true
    })
    return matchingVariant ? isVariantPurchasable(matchingVariant) : false
  }

  function getOptionInputLabel(productEl, input) {
    let label = input.nextElementSibling
    if (!label || !label.matches('.opt-label')) {
      label = input.id ? productEl.querySelector(`label[for="${input.id}"]`) : null
    }
    return label
  }

  function updateStlOptionAvailability(productEl) {
    const data = getProductData(productEl)
    if (!data?.variants?.length) return

    clearStlSwatchAvailability(productEl)

    const applySizeAvailability = () => {
      const selectedOptions = getSelectedOptions(productEl)
      productEl.querySelectorAll('.option-selector--size').forEach((selectorContainer) => {
        const optionIndex = parseInt(selectorContainer.getAttribute('data-option-index'), 10)
        if (Number.isNaN(optionIndex)) return

        selectorContainer.querySelectorAll('input[type="radio"]').forEach((input) => {
          const isAvailable = isOptionValueAvailable(data, selectedOptions, optionIndex, input.value)
          const label = getOptionInputLabel(productEl, input)

          if (isAvailable) {
            input.classList.remove('is-unavailable', 'js-option-is-unavailable')
            input.disabled = false
            label?.classList.remove('is-unavailable')
            label?.removeAttribute('aria-disabled')
          } else {
            if (input.checked) input.checked = false
            input.classList.add('is-unavailable', 'js-option-is-unavailable')
            input.disabled = true
            label?.classList.add('is-unavailable')
            label?.setAttribute('aria-disabled', 'true')
          }
        })
      })
    }

    applySizeAvailability()

    let autoSelected = false
    productEl.querySelectorAll('.option-selector--size').forEach((selectorContainer) => {
      const inputs = selectorContainer.querySelectorAll('input[type="radio"]')
      const checkedAvailable = [...inputs].find((input) => input.checked && !input.disabled)
      if (checkedAvailable) return
      const firstAvailable = [...inputs].find((input) => !input.classList.contains('is-unavailable'))
      if (!firstAvailable) return
      firstAvailable.disabled = false
      firstAvailable.checked = true
      autoSelected = true
    })

    if (autoSelected) applySizeAvailability()
  }

  function normalizeProductData(data) {
    if (!data || typeof data !== 'object') return null
    if (!Array.isArray(data.variants)) {
      data.variants = []
    }
    return data
  }

  function cacheProductData(data, blockId, productId) {
    const normalized = normalizeProductData(data)
    if (!normalized) return null
    if (blockId) stlProductDataByBlockId.set(String(blockId), normalized)
    if (productId) stlProductDataByProductId.set(String(productId), normalized)
    return normalized
  }

  function tryParseProductJson(raw) {
    if (!raw || !String(raw).trim()) {
      return { data: null, reason: 'JSON_EMPTY' }
    }
    try {
      const parsed = JSON.parse(String(raw).trim())
      const normalized = normalizeProductData(parsed)
      if (!normalized) {
        return { data: null, reason: 'JSON_PARSE_ERROR', parseError: 'not an object' }
      }
      return { data: normalized, reason: null }
    } catch (e) {
      return { data: null, reason: 'JSON_PARSE_ERROR', parseError: e.message }
    }
  }

  function readJsonFromElement(el) {
    if (!el) return ''
    if (el.tagName === 'TEXTAREA') {
      return el.value || el.textContent || ''
    }
    return el.textContent || el.innerHTML || ''
  }

  function readJsonFromTemplateSource(sourceEl) {
    const el =
      sourceEl.querySelector('textarea[data-product-json]') ||
      sourceEl.querySelector('textarea[data-stl-product-json]') ||
      sourceEl.querySelector('script[data-product-json]')
    return el ? readJsonFromElement(el) : ''
  }

  function hydrateStlProductJsonCache(sectionEl) {
    if (!sectionEl) return
    sectionEl.querySelectorAll('template.stl-look-modal-data').forEach((template) => {
      if (!template.content) return
      template.content.querySelectorAll('.stl-modal-product-source').forEach((source) => {
        const blockId = source.dataset.productBlockId
        const productId = source.dataset.productId
        const raw = readJsonFromTemplateSource(source)
        const { data } = tryParseProductJson(raw)
        if (data) cacheProductData(data, blockId, productId)
      })
    })
    sectionEl.querySelectorAll('.stl-modal-product').forEach((productEl) => {
      const blockId = productEl.dataset.productBlockId
      const productId = productEl.dataset.productId
      const el = getProductJsonElement(productEl)
      const { data } = tryParseProductJson(readJsonFromElement(el))
      if (data) cacheProductData(data, blockId, productId)
    })
  }

  function getProductsRootUrl() {
    const root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      (typeof theme !== 'undefined' && theme.routes && theme.routes.root) ||
      '/'
    return root.endsWith('/') ? root : `${root}/`
  }

  function normalizeFetchedProduct(apiProduct) {
    if (!apiProduct) return null
    const variants = (apiProduct.variants || []).map((v) => ({
      id: v.id,
      title: v.title,
      price: v.price,
      compare_at_price: v.compare_at_price,
      available: v.available,
      options: v.options,
      option1: v.option1,
      option2: v.option2,
      option3: v.option3,
    }))
    return normalizeProductData({
      id: apiProduct.id,
      handle: apiProduct.handle,
      title: apiProduct.title,
      options: apiProduct.options || [],
      variants,
    })
  }

  function fetchProductDataByHandle(handle) {
    if (!handle) return Promise.resolve(null)
    const key = String(handle)
    if (stlProductFetchByHandle.has(key)) {
      return stlProductFetchByHandle.get(key)
    }
    const promise = fetch(`${getProductsRootUrl()}products/${encodeURIComponent(key)}.js`)
      .then((response) => (response.ok ? response.json() : null))
      .then((json) => normalizeFetchedProduct(json))
      .catch(() => null)
    stlProductFetchByHandle.set(key, promise)
    return promise
  }

  function getProductJsonElement(productEl) {
    const productId = productEl.dataset.productId
    const selectors = [
      'textarea[data-product-json]',
      'textarea[data-stl-product-json]',
      '[id^="ProductJson-stl-"]',
      'script[data-product-json]',
      'script[data-stl-product-json]',
      '.product-form textarea[data-product-json]',
      '.product-form script[data-product-json]',
    ]
    for (const sel of selectors) {
      const el = productEl.querySelector(sel)
      if (el) return el
    }
    if (productId) {
      const byProduct = document.getElementById(`ProductJson-${productId}`)
      if (byProduct) return byProduct
    }
    return null
  }

  function getProductData(productEl) {
    const blockId = productEl.dataset.productBlockId
    const productId = productEl.dataset.productId
    if (blockId && stlProductDataByBlockId.has(String(blockId))) {
      return stlProductDataByBlockId.get(String(blockId))
    }
    if (productId && stlProductDataByProductId.has(String(productId))) {
      return stlProductDataByProductId.get(String(productId))
    }
    const el = getProductJsonElement(productEl)
    const { data } = tryParseProductJson(readJsonFromElement(el))
    if (data) return cacheProductData(data, blockId, productId)
    return null
  }

  function findPanel(modal, lookId) {
    if (!lookId || !modal) return null
    return Array.from(modal.querySelectorAll('.stl-modal__panel')).find(
      (p) => p.getAttribute('data-panel-for') === lookId
    )
  }

  function getPanelProductsScroller(panel) {
    return (
      panel?.querySelector('[data-stl-products-list]') ||
      panel?.querySelector('.stl-modal__products') ||
      null
    )
  }

  function clampScrollTop(el, top) {
    if (!el) return 0
    const maxScroll = Math.max(0, el.scrollHeight - el.clientHeight)
    return Math.min(Math.max(0, top), maxScroll)
  }

  const STL_SCROLL_BOTTOM_THRESHOLD = 120

  function captureProductsScroll(panel, productEl) {
    const el = getPanelProductsScroller(panel)
    if (!el) return null
    const fromBottom = el.scrollHeight - el.scrollTop - el.clientHeight
    const resolvedProduct =
      productEl && panel.contains(productEl)
        ? productEl
        : null
    const isLastProduct =
      resolvedProduct &&
      resolvedProduct === el.querySelector('.stl-modal-product:last-child')
    const snap = {
      el,
      top: el.scrollTop,
      fromBottom,
      nearBottom: fromBottom <= STL_SCROLL_BOTTOM_THRESHOLD,
      pinListBottom: isLastProduct && fromBottom <= STL_SCROLL_BOTTOM_THRESHOLD,
      productEl: resolvedProduct,
      offsetInView: null,
    }
    if (snap.productEl && !snap.nearBottom) {
      snap.offsetInView =
        snap.productEl.getBoundingClientRect().top - el.getBoundingClientRect().top
    }
    return snap
  }

  function restoreProductsScroll(scroll) {
    if (!scroll?.el?.isConnected) return
    const el = scroll.el
    if (scroll.nearBottom) {
      let fromBottom =
        scroll.fromBottom != null
          ? scroll.fromBottom
          : el.scrollHeight - el.scrollTop - el.clientHeight
      if (scroll.pinListBottom) fromBottom = 0
      el.scrollTop = clampScrollTop(
        el,
        el.scrollHeight - el.clientHeight - fromBottom
      )
      return
    }
    if (scroll.productEl?.isConnected && scroll.offsetInView != null) {
      const nextOffset =
        scroll.productEl.getBoundingClientRect().top - el.getBoundingClientRect().top
      el.scrollTop = clampScrollTop(el, el.scrollTop + (nextOffset - scroll.offsetInView))
      return
    }
    el.scrollTop = clampScrollTop(el, scroll.top)
  }

  function runProductsScrollRestore(scroll) {
    if (!scroll) return
    restoreProductsScroll(scroll)
    requestAnimationFrame(() => {
      restoreProductsScroll(scroll)
      requestAnimationFrame(() => restoreProductsScroll(scroll))
    })
  }

  function bindStlPanelOptionScrollFix(panel) {
    if (!panel || panel.dataset.stlOptionScrollFixBound === 'true') return
    panel.dataset.stlOptionScrollFixBound = 'true'

    const scroller = getPanelProductsScroller(panel)
    scroller?.addEventListener(
      'mousedown',
      (e) => {
        const productEl = e.target.closest('.stl-modal-product')
        if (!productEl) return
        panel._stlActiveScrollLock = captureProductsScroll(panel, productEl)
      },
      true
    )

    panel.addEventListener(
      'mousedown',
      (e) => {
        const label = e.target.closest('.opt-label')
        const directInput = e.target.matches('input[type="radio"]') ? e.target : null
        if (!label && !directInput) return

        const productEl = (label || directInput).closest('.stl-modal-product')
        if (!productEl || !panel.contains(productEl)) return

        const selectorContainer = (label || directInput).closest('.option-selector')
        if (!selectorContainer || selectorContainer.dataset.selectorType === 'dropdown') return

        const scroll = captureProductsScroll(panel, productEl)
        panel._stlActiveScrollLock = scroll

        let input = directInput
        if (!input && label) {
          const forId = label.getAttribute('for')
          if (forId) {
            input = productEl.querySelector(`#${CSS.escape(forId)}`)
          }
          if (!input) {
            const prev = label.previousElementSibling
            if (prev?.matches('input[type="radio"]')) input = prev
          }
        }

        if (!input || input.disabled || input.classList.contains('is-unavailable')) {
          e.preventDefault()
          e.stopPropagation()
          return
        }

        e.preventDefault()
        if (input) {
          input.focus({ preventScroll: true })
        }

        if (!input.checked) {
          input.checked = true
          input.dispatchEvent(new Event('change', { bubbles: true }))
        } else {
          runProductsScrollRestore(scroll)
        }
      },
      true
    )

    panel.addEventListener(
      'focusin',
      (e) => {
        if (!e.target.closest('.stl-modal-product')) return
        const scroll =
          panel._stlActiveScrollLock ||
          captureProductsScroll(panel, e.target.closest('.stl-modal-product'))
        runProductsScrollRestore(scroll)
      },
      true
    )
  }

  function updateStlDialogScrollbar(panel) {
    const scroller = getPanelProductsScroller(panel)
    const bar = panel?.querySelector('[data-stl-dialog-scrollbar]')
    const thumb = panel?.querySelector('[data-stl-dialog-scrollbar-thumb]')
    if (!scroller || !bar || !thumb) return

    const { scrollHeight, clientHeight, scrollTop } = scroller
    if (scrollHeight <= clientHeight + 2) {
      bar.hidden = true
      return
    }

    bar.hidden = false
    const trackHeight = bar.clientHeight
    if (trackHeight <= 0) return

    const thumbHeight = Math.max(24, Math.round((clientHeight / scrollHeight) * trackHeight))
    const maxThumbTop = Math.max(0, trackHeight - thumbHeight)
    const scrollRange = scrollHeight - clientHeight
    const thumbTop = scrollRange > 0 ? (scrollTop / scrollRange) * maxThumbTop : 0

    thumb.style.height = `${thumbHeight}px`
    thumb.style.transform = `translate3d(0, ${thumbTop}px, 0)`
  }

  function bindStlProductsScrollStabilizer(panel) {
    const scroller = getPanelProductsScroller(panel)
    const footer = panel?.querySelector('.stl-modal__footer')
    if (!scroller || panel.dataset.stlScrollStabilizerBound === 'true') return
    panel.dataset.stlScrollStabilizerBound = 'true'

    const stabilizeAfterLayout = () => {
      const lock = panel._stlActiveScrollLock
      if (lock?.nearBottom) {
        runProductsScrollRestore(lock)
        return
      }
      const fromBottom = scroller.scrollHeight - scroller.scrollTop - scroller.clientHeight
      if (fromBottom > STL_SCROLL_BOTTOM_THRESHOLD) return
      scroller.scrollTop = clampScrollTop(
        scroller,
        scroller.scrollHeight - scroller.clientHeight - fromBottom
      )
    }

    if (typeof ResizeObserver !== 'undefined') {
      const layoutObserver = new ResizeObserver(() => {
        requestAnimationFrame(() => {
          stabilizeAfterLayout()
          updateStlDialogScrollbar(panel)
        })
      })
      layoutObserver.observe(scroller)
      if (footer) layoutObserver.observe(footer)
      panel._stlScrollLayoutObserver = layoutObserver
    }
  }

  function bindStlDialogScrollbar(panel) {
    const scroller = getPanelProductsScroller(panel)
    const bar = panel?.querySelector('[data-stl-dialog-scrollbar]')

    bindStlProductsScrollStabilizer(panel)

    if (!scroller || !bar) return

    if (panel.dataset.stlDialogScrollbarBound !== 'true') {
      panel.dataset.stlDialogScrollbarBound = 'true'
      scroller.addEventListener('scroll', () => updateStlDialogScrollbar(panel), { passive: true })
      if (typeof ResizeObserver !== 'undefined') {
        const observer = new ResizeObserver(() => updateStlDialogScrollbar(panel))
        observer.observe(scroller)
        observer.observe(bar)
        panel._stlDialogScrollbarObserver = observer
      }
    }

    updateStlDialogScrollbar(panel)
  }

  let overlayCloseBound = false

  function bindGlobalOverlayClose() {
    if (overlayCloseBound) return
    overlayCloseBound = true
    const pageOverlay = document.querySelector('.box-overlay')
    pageOverlay?.addEventListener('click', () => {
      document.querySelectorAll('.stl-modal.is-open').forEach((modal) => {
        modal.classList.remove('is-open')
        modal.setAttribute('aria-hidden', 'true')
      })
      document.documentElement.classList.remove('popup-overlay')
      pageOverlay.classList.add('hidden')
      document.body.classList.remove('stl-modal-open')
    })
  }

  class ShopTheLookSection {
    constructor(root) {
      this.root = root
      this.sectionId = String(root.dataset.sectionId || '')
      this.moneyFormat = root.dataset.moneyFormat
      this.modal = root.querySelector('.stl-modal')
      this.modalHome = this.modal?.parentElement
      this.activePanel = null
      this.swiper = null

      if (!this.modal) {
        return
      }

      if (this.modal.parentElement !== document.body) {
        document.body.appendChild(this.modal)
      }

      bindGlobalOverlayClose()

      this.lookCount = parseInt(this.root.dataset.stlLookCount || '0', 10)
      this.layoutDesktop = this.root.dataset.stlLayoutDesktop || 'auto'
      this.layoutMobile = this.root.dataset.stlLayoutMobile || 'auto'
      this._carouselResizeTimer = null

      try {
        this.syncCarouselLayout()
        window.addEventListener('resize', () => {
          clearTimeout(this._carouselResizeTimer)
          this._carouselResizeTimer = setTimeout(() => this.syncCarouselLayout(), 150)
        })
        this.bindHotspots()
        this.initPanels()
      } catch (err) {
        console.error('[Shop the Look] Init error:', err)
      }

      instances.set(this.sectionId, this)
    }

    wantsCarouselAtCurrentBreakpoint() {
      const mobile = window.matchMedia('(max-width: 767px)').matches
      const mode = mobile ? this.layoutMobile : this.layoutDesktop
      if (mode === 'carousel') return true
      if (mode === 'grid') return false
      return this.lookCount > 3
    }

    syncCarouselLayout() {
      const swiperEl = this.root.querySelector('.stl-looks-swiper')
      if (!swiperEl) return

      const wantsCarousel = this.wantsCarouselAtCurrentBreakpoint()
      const arrows = this.root.querySelector('[data-stl-carousel-arrows]')

      this.root.classList.toggle('stl-carousel-active', wantsCarousel)
      if (arrows) {
        arrows.classList.toggle('hidden', !wantsCarousel)
      }

      if (wantsCarousel) {
        if (!this.swiper && typeof Swiper !== 'undefined') {
          this.initCarouselInstance(swiperEl)
        } else if (this.swiper) {
          this.swiper.update()
        }
      } else if (this.swiper) {
        this.swiper.destroy(true, true)
        this.swiper = null
      }
    }

    initCarouselInstance(swiperEl) {
      const prev = this.root.querySelector('.stl-swiper-prev')
      const next = this.root.querySelector('.stl-swiper-next')
      this.swiper = new Swiper(swiperEl, {
        loop: false,
        spaceBetween: 16,
        slidesPerView: 'auto',
        mousewheel: { forceToAxis: true },
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
        breakpoints: {
          768: { spaceBetween: 10 },
        },
      })
    }

    positionHotspotCard(btn, card) {
      const HOTSPOT_CARD_GAP = 10
      const EDGE_INSET = 8
      const container = btn.closest('.stl-look__hotspots')
      if (!container || !card) return

      const containerRect = container.getBoundingClientRect()
      const btnRect = btn.getBoundingClientRect()
      const centerX = btnRect.left + btnRect.width / 2 - containerRect.left
      const isMobile = window.matchMedia('(max-width: 767px)').matches

      let topY
      if (isMobile) {
        const cardHeight = card.getBoundingClientRect().height
        topY = btnRect.top - containerRect.top - cardHeight - HOTSPOT_CARD_GAP
        topY = Math.max(EDGE_INSET, topY)
      } else {
        topY = btnRect.bottom - containerRect.top + HOTSPOT_CARD_GAP
      }

      const cardWidth = card.getBoundingClientRect().width
      const minX = cardWidth / 2 + EDGE_INSET
      const maxX = containerRect.width - cardWidth / 2 - EDGE_INSET
      const leftX = Math.min(Math.max(centerX, minX), maxX)

      card.style.left = `${leftX}px`
      card.style.top = `${topY}px`
      card.style.transform = 'translateX(-50%)'
    }

    bindHotspots() {
      const repositionOpenHotspotCards = () => {
        this.root.querySelectorAll('.stl-hotspot-card:not(.hidden)').forEach((card) => {
          const blockId = card.getAttribute('data-hotspot-for')
          const btn = this.root.querySelector(`.stl-hotspot[data-block-id="${blockId}"]`)
          if (btn) this.positionHotspotCard(btn, card)
        })
      }

      if (!this._hotspotResizeBound) {
        this._hotspotResizeBound = true
        window.addEventListener('resize', () => {
          clearTimeout(this._hotspotResizeTimer)
          this._hotspotResizeTimer = setTimeout(repositionOpenHotspotCards, 100)
        })
      }

      this.root.querySelectorAll('.stl-hotspot').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation()
          const blockId = btn.dataset.blockId
          const card = this.root.querySelector(`[data-hotspot-for="${blockId}"]`)
          if (!card) return
          const wasHidden = card.classList.contains('hidden')
          this.root.querySelectorAll('.stl-hotspot-card').forEach((c) => c.classList.add('hidden'))
          if (wasHidden) {
            card.classList.remove('hidden')
            this.positionHotspotCard(btn, card)
          }
        })
      })

      this.root.querySelectorAll('.stl-hotspot-card__close').forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation()
          btn.closest('.stl-hotspot-card')?.classList.add('hidden')
        })
      })
    }

    initPanels() {
      this.modal.querySelectorAll('[data-stl-close]').forEach((el) => {
        el.addEventListener('click', (e) => {
          e.preventDefault()
          e.stopPropagation()
          this.closeModal()
        })
      })

      this.modal.querySelectorAll('.stl-modal__panel').forEach((panel) => {
        const onPanelVariantChange = (e) => {
          if (stlProgrammaticUpdate) return
          const productEl = e.target.closest('.stl-modal-product')
          if (!productEl || !panel.contains(productEl)) return
          if (!panel._stlActiveScrollLock) {
            panel._stlActiveScrollLock = captureProductsScroll(panel, productEl)
          }
          this.schedulePanelStateUpdate(panel)
        }
        panel.addEventListener('change', onPanelVariantChange)
        panel.addEventListener('click', (e) => {
          const label = e.target.closest('.opt-label')
          if (!label) return
          const productEl = label.closest('.stl-modal-product')
          if (!productEl || !panel.contains(productEl)) return
          const selectorContainer = label.closest('.option-selector')
          const forId = label.getAttribute('for')
          const input =
            forId && productEl ? productEl.querySelector(`#${CSS.escape(forId)}`) : null
          if (
            selectorContainer &&
            isStlSizeSelector(selectorContainer) &&
            (input?.disabled || input?.classList.contains('is-unavailable'))
          ) {
            e.preventDefault()
            e.stopPropagation()
          }
        })
        const submit = panel.querySelector('[data-stl-submit]')
        submit?.addEventListener('click', (e) => {
          e.preventDefault()
          if (submit.disabled) return
          this.submitPanel(panel, submit)
        })
        try {
          this.autoSelectVariants(panel)
          this.updatePanelState(panel)
        } catch (err) {
          console.warn('[Shop the Look] Panel preload skipped:', err)
        }
        bindStlDialogScrollbar(panel)
        bindStlPanelOptionScrollFix(panel)
      })
    }

    schedulePanelStateUpdate(panel) {
      if (panel._stlStateRafId != null) return
      const scroll =
        panel._stlActiveScrollLock || captureProductsScroll(panel, null)
      panel._stlStateRafId = requestAnimationFrame(() => {
        panel._stlStateRafId = null
        this.updatePanelState(panel)
        runProductsScrollRestore(scroll)
        requestAnimationFrame(() => {
          runProductsScrollRestore(scroll)
          updateStlDialogScrollbar(panel)
          requestAnimationFrame(() => {
            runProductsScrollRestore(scroll)
            updateStlDialogScrollbar(panel)
            panel._stlActiveScrollLock = null
          })
        })
      })
    }

    updateOptionLabels(productEl) {
      productEl.querySelectorAll('.option-selector').forEach((selector) => {
        const legend = selector.querySelector('legend.label')
        if (!legend) return
        const base =
          legend.dataset.stlOptionLabel ||
          legend.dataset.stlLegendBase ||
          legend.textContent.replace(/:\s*.*$/, '').trim()
        if (!legend.dataset.stlLegendBase) {
          legend.dataset.stlLegendBase = base
        }
        if (!legend.dataset.stlOptionLabel) {
          legend.dataset.stlOptionLabel = base
        }
        let value = ''
        if (selector.dataset.selectorType === 'dropdown') {
          const select = selector.querySelector('select')
          value = select?.value || ''
        } else {
          const checked = selector.querySelector('input[type="radio"]:checked')
          value = checked?.value || ''
        }
        legend.textContent = value ? `${base}: ${value}` : `${base}:`
      })
    }

    autoSelectVariants(panel) {
      stlProgrammaticUpdate = true
      try {
        panel.querySelectorAll('.stl-modal-product').forEach((productEl) => {
          const data = getProductData(productEl)
          if (!data || !data.variants.length) return
          const selectors = productEl.querySelectorAll('.option-selector')
          if (!selectors.length) return

          const first = data.variants.find((v) => v.available) || data.variants[0]
          if (!first) return
          setProductOptionValues(productEl, variantOptionValues(first), { silent: true })
          updateStlOptionAvailability(productEl)
          this.updateOptionLabels(productEl)
        })
      } finally {
        stlProgrammaticUpdate = false
      }
    }

    getPanelVariants(panel) {
      const items = []
      let valid = true
      const productRows = panel.querySelectorAll('.stl-modal-product')
      if (!productRows.length) {
        return { items: [], valid: false }
      }
      productRows.forEach((productEl) => {
        const data = getProductData(productEl)
        if (!data) {
          valid = false
          return
        }
        const selectors = productEl.querySelectorAll('.option-selector')
        let options = getSelectedOptions(productEl)
        if (selectors.length > 0 && options.some((opt) => !opt)) {
          forceFirstAvailableVariant(productEl)
          options = getSelectedOptions(productEl)
        }
        if (selectors.length > 0 && options.some((opt) => !opt)) {
          valid = false
          return
        }
        let variant = findVariant(data, options)
        if (!variant && selectors.length) {
          forceFirstAvailableVariant(productEl)
          options = getSelectedOptions(productEl)
          variant = findVariant(data, options)
        }
        if (!variant) {
          valid = false
          return
        }
        if (!isVariantPurchasable(variant)) {
          if (reconcileStlProductOptions(productEl)) {
            options = getSelectedOptions(productEl)
            variant = findVariant(data, options)
          }
        }
        if (!variant || !isVariantPurchasable(variant)) {
          valid = false
          return
        }
        items.push(variant)
        const priceEl = productEl.querySelector('[data-product-price]')
        if (priceEl) priceEl.textContent = formatMoney(variant.price, this.moneyFormat)
      })
      valid = valid && items.length === productRows.length
      return { items, valid }
    }

    updatePanelState(panel) {
      stlProgrammaticUpdate = true
      try {
        panel.querySelectorAll('.stl-modal-product').forEach((productEl) => {
          this.updateOptionLabels(productEl)
          updateStlOptionAvailability(productEl)
          if (reconcileStlProductOptions(productEl)) {
            updateStlOptionAvailability(productEl)
            this.updateOptionLabels(productEl)
          }
        })
      } finally {
        stlProgrammaticUpdate = false
      }
      const { items, valid } = this.getPanelVariants(panel)
      const submit = panel.querySelector('[data-stl-submit]')
      const totalEl = panel.querySelector('[data-stl-total]')
      const compareEl = panel.querySelector('[data-stl-compare]')
      const discount = parseInt(panel.dataset.discountPercent || '0', 10) || 0

      const subtotal = items.reduce((sum, v) => sum + v.price, 0)
      const compareTotal = items.reduce((sum, v) => {
        const effectiveCompare =
          v.compare_at_price && v.compare_at_price > 0 ? v.compare_at_price : v.price
        return sum + effectiveCompare
      }, 0)
      const discounted = Math.round(subtotal * (1 - discount / 100))

      if (totalEl && items.length) {
        totalEl.textContent = formatMoney(discounted, this.moneyFormat)
      }
      if (compareEl && items.length) {
        compareEl.textContent =
          compareTotal > discounted ? formatMoney(compareTotal, this.moneyFormat) : ''
      }
      const badgeEl = panel.querySelector('[data-stl-badge]')
      if (badgeEl) {
        badgeEl.style.display = discount > 0 ? '' : 'none'
        if (discount > 0) badgeEl.textContent = `-${discount}%`
      }
      if (submit) submit.disabled = !valid || items.length === 0
      panel._stlVariants = items
    }

    async ensurePanelProductData(panel) {
      const rows = panel.querySelectorAll('.stl-modal-product')
      const tasks = [...rows].map(async (productEl) => {
        if (getProductData(productEl)) return
        const handle = productEl.dataset.productHandle
        if (!handle) return
        const data = await fetchProductDataByHandle(handle)
        if (data) {
          cacheProductData(data, productEl.dataset.productBlockId, productEl.dataset.productId)
        }
      })
      await Promise.all(tasks)
    }

    async openModal(lookId) {
      if (!this.modal) return

      const panel = findPanel(this.modal, lookId)
      if (!panel) {
        return
      }

      const productRows = panel.querySelectorAll('.stl-modal-product')
      if (!productRows.length) {
        return
      }

      this.modal.querySelectorAll('.stl-modal__panel').forEach((p) => p.classList.add('hidden'))
      panel.classList.remove('hidden')
      this.activePanel = panel

      this.modal.classList.add('is-open')
      this.modal.setAttribute('aria-hidden', 'false')
      document.documentElement.classList.add('popup-overlay')
      const overlay = document.querySelector('.box-overlay')
      if (overlay) overlay.classList.remove('hidden')
      document.body.classList.add('stl-modal-open')

      try {
        await this.ensurePanelProductData(panel)
        this.autoSelectVariants(panel)
        this.updatePanelState(panel)
        requestAnimationFrame(() => {
          bindStlDialogScrollbar(panel)
          requestAnimationFrame(() => updateStlDialogScrollbar(panel))
        })
      } catch (err) {
        console.error('[Shop the Look] Variant init failed:', err)
      }
    }

    closeModal() {
      if (!this.modal) return
      this.modal.classList.remove('is-open')
      this.modal.setAttribute('aria-hidden', 'true')
      document.documentElement.classList.remove('popup-overlay')
      const overlay = document.querySelector('.box-overlay')
      if (overlay) overlay.classList.add('hidden')
      document.body.classList.remove('stl-modal-open')
      this.activePanel = null
    }

    async submitPanel(panel, submitBtn) {
      await this.ensurePanelProductData(panel)
      this.updatePanelState(panel)
      const variants = panel._stlVariants
      const submit = submitBtn || panel.querySelector('[data-stl-submit]')
      if (!variants || !variants.length || (submit && submit.disabled)) return

      const loading = this.modal.querySelector('.stl-modal__loading')
      const submitLabel = submit?.querySelector('span')
      const defaultLabel = submitLabel?.textContent || ''

      loading?.classList.remove('hidden')
      if (submit) submit.disabled = true

      const items = variants.map((v) => ({ id: v.id, quantity: 1 }))
      try {
        const response = await fetch(getCartAddUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        })
        if (!response.ok) {
          let message = 'Cart add failed'
          try {
            const errorBody = await response.json()
            if (errorBody?.description) message = errorBody.description
            else if (errorBody?.message) message = errorBody.message
          } catch (parseErr) {
            /* use default message */
          }
          throw new Error(message)
        }
        this.closeModal()
        openMiniCartAfterAdd()
      } catch (err) {
        console.error('[Shop the Look]', err)
        const msg =
          err && err.message
            ? err.message
            : typeof theme !== 'undefined' && theme.strings && theme.strings.products_product_adding_to_cart
              ? theme.strings.products_product_adding_to_cart
              : 'Could not add items to cart'
        if (typeof window.alert === 'function') {
          window.alert(msg)
        }
        this.updatePanelState(panel)
      } finally {
        loading?.classList.add('hidden')
        if (submitLabel && defaultLabel) submitLabel.textContent = defaultLabel
      }
    }

    destroy() {
      this.swiper?.destroy()
      instances.delete(this.sectionId)
      if (this.modal && this.modalHome && this.modal.parentElement === document.body) {
        this.modalHome.appendChild(this.modal)
      }
    }
  }

  function initSection(sectionEl) {
    if (!sectionEl) return
    const root = sectionEl.querySelector('.stl-section')
    if (!root) return
    const id = String(root.dataset.sectionId || '')
    if (instances.has(id)) {
      instances.get(id).destroy()
    }
    hydrateStlProductJsonCache(sectionEl)
    new ShopTheLookSection(root)
  }

  function initAll() {
    document.querySelectorAll('[id^="shopify-section-"] .stl-section').forEach((root) => {
      initSection(root.closest('[id^="shopify-section-"]'))
    })
  }

  function openFromTrigger(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }
    const trigger = event?.currentTarget || event?.target?.closest?.('[data-open-look-modal]')
    if (!trigger) return

    const lookId = trigger.getAttribute('data-open-look-modal')
    const lookEl = trigger.closest('.stl-look')
    const productCount = parseInt(lookEl?.dataset?.stlProductCount || '0', 10)
    if (productCount < 1) {
      return
    }

    let sectionId = trigger.getAttribute('data-section-id')
    const sectionRoot = trigger.closest('.stl-section')
    if (!sectionId && sectionRoot) {
      sectionId = sectionRoot.dataset.sectionId
    }
    sectionId = String(sectionId || '')

    let instance = instances.get(sectionId)
    if (!instance && sectionRoot) {
      initSection(sectionRoot.closest('[id^="shopify-section-"]'))
      instance = instances.get(sectionId)
    }
    if (!instance) return
    instance.openModal(lookId)
  }

  window.hokoStlOpen = openFromTrigger

  document.addEventListener(
    'click',
    (e) => {
      const trigger = e.target.closest('[data-open-look-modal]')
      if (!trigger) return
      openFromTrigger({ preventDefault: () => e.preventDefault(), stopPropagation: () => e.stopPropagation(), currentTarget: trigger, target: e.target })
    },
    true
  )

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return
    document.querySelectorAll('.stl-modal.is-open').forEach((modal) => {
      modal.classList.remove('is-open')
      modal.setAttribute('aria-hidden', 'true')
    })
    document.documentElement.classList.remove('popup-overlay')
    document.querySelector('.box-overlay')?.classList.add('hidden')
    document.body.classList.remove('stl-modal-open')
  })

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll)
  } else {
    initAll()
  }

  document.addEventListener('shopify:section:load', (e) => {
    initSection(e.target)
  })

  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('.stl-section')
    if (!root) return
    const id = String(root.dataset.sectionId || '')
    if (instances.has(id)) {
      instances.get(id).destroy()
    }
  })
})()
